import { useSaveEsgDataPlatform } from '@Domains/Esg/EsgDataPlatform';
import { useDisclosure } from '@hooks/useDisclosure';
import SaveIcon from '@mui/icons-material/Save';
import { Alert, Button, Snackbar } from '@mui/material';
import { findUserRoles } from '@Utils/roleUtils';
import { updateCompletedSection } from '@Utils/updateCompletedSection';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { useProfile } from 'src/Constant/UserProfileContext/UserProfileProvider';
import { IEsgDataPlatformFormValues } from '../EsgPlatformFormProvider/types';
import { mapToEsgDataPlatformPayload } from './utils';

const EsgPlatformSaveButton = () => {
  const { getValues, trigger, setValue } =
    useFormContext<IEsgDataPlatformFormValues>();
  const { id } = useParams();
  const [{ loading, error }, saveEsgPlans] = useSaveEsgDataPlatform(id);
  const [openedSnackbar, { open: openSnackbar, close: closeSnackbar }] =
    useDisclosure();
  const { refetchProgressWithUpdate, isPublished } = useProgressBar();
  const { user } = useProfile();

  const handleSave = async () => {
    if (user) {
      const formValues = getValues();
      const { cvupCreatorRole, cvupApproverRole } =
        findUserRoles(user.N_ROLES) || {};

      const updatedCompletedSection = updateCompletedSection(
        formValues.completedSection,
        cvupCreatorRole ? { N_ROLE: cvupCreatorRole } : undefined,
        cvupApproverRole ? { N_ROLE: cvupApproverRole } : undefined
      );

      const completeFormValues = {
        ...formValues,
        completedSection: updatedCompletedSection
          ? {
              ...updatedCompletedSection,
              isCompletedTh: updatedCompletedSection.isCompletedTh ?? false,
              isCompletedEn: updatedCompletedSection.isCompletedEn ?? false,
              dateTh: updatedCompletedSection.dateTh,
              dateEn: updatedCompletedSection.dateEn,
            }
          : undefined,
      };

      const payload = mapToEsgDataPlatformPayload(completeFormValues);

      try {
        await saveEsgPlans({
          data: payload,
        });

        if (updatedCompletedSection) {
          setValue('completedSection', {
            ...updatedCompletedSection,
            isCompletedTh: updatedCompletedSection.isCompletedTh ?? false,
            isCompletedEn: updatedCompletedSection.isCompletedEn ?? false,
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        refetchProgressWithUpdate(true);
        trigger();
        openSnackbar();
      }
    }
  };

  return (
    <>
      <Button
        type="submit"
        color="inherit"
        startIcon={<SaveIcon />}
        onClick={handleSave}
        loading={loading}
        disabled={isPublished}
      >
        บันทึก
      </Button>
      <Snackbar
        open={openedSnackbar}
        autoHideDuration={2000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          severity={!!error ? 'error' : 'success'}
          onClose={closeSnackbar}
          sx={{
            alignItems: 'center',
            marginBottom: 6,
            '.MuiAlert-icon': { py: 1 },
            '.MuiAlert-message': { py: 1 },
          }}
        >
          {!!error ? 'เกิดข้อผิดพลาดในการบันทึก' : 'บันทึกสําเร็จ'}
        </Alert>
      </Snackbar>
    </>
  );
};
export default EsgPlatformSaveButton;
